import React from 'react';
import { getPasswordRuleChecks } from '../utils/passwordPolicy';

/**
 * Live checklist shown while the user chooses a password on signup flows.
 */
export default function PasswordRequirements({ password, id = 'password-requirements' }) {
  const checks = getPasswordRuleChecks(password);
  const allMet = checks.every((c) => c.met);

  return (
    <div
      id={id}
      role="group"
      aria-label="Password requirements"
      style={{
        marginTop: 4,
        padding: '10px 12px',
        borderRadius: 8,
        background: 'var(--mist-50, #f8f9fa)',
        border: `1px solid ${allMet && password ? 'var(--sage-400, #7a9e7e)' : 'var(--mist-200, #e8eaed)'}`,
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--dusk-600, #555)', marginBottom: 6 }}>
        Password must include:
      </div>
      <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'grid', gap: 4 }}>
        {checks.map((check) => (
          <li
            key={check.id}
            style={{
              fontSize: 13,
              display: 'flex',
              alignItems: 'flex-start',
              gap: 8,
              color: check.met ? 'var(--sage-700, #3d6b45)' : 'var(--dusk-500, #666)',
            }}
          >
            <span aria-hidden="true" style={{ flexShrink: 0, width: 16, textAlign: 'center' }}>
              {check.met ? '✓' : '○'}
            </span>
            <span>{check.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
